import React from 'react';

export function Expedition() {
  interface Signatory {
    name: string;
    email: string;
    cprNumber: string;
  }

  const [formData, setFormData] = React.useState({
    customer: '',
    debtorNumber: '',
    agreementNumber: ''
  });

  const [signatoryCount, setSignatoryCount] = React.useState<number>(1);
  const [signatories, setSignatories] = React.useState<Signatory[]>([
    { name: '', email: '', cprNumber: '' }
  ]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSignatoryCountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const count = parseInt(e.target.value) || 0;
    setSignatoryCount(count);
    
    // Update signatories array based on new count
    if (count > signatories.length) {
      // Add new empty signatories
      setSignatories([
        ...signatories,
        ...Array(count - signatories.length).fill({ name: '', email: '', cprNumber: '' })
      ]);
    } else {
      // Remove excess signatories
      setSignatories(signatories.slice(0, count));
    }
  };

  const handleSignatoryChange = (index: number, field: keyof Signatory, value: string) => {
    const newSignatories = [...signatories];
    newSignatories[index] = {
      ...newSignatories[index],
      [field]: value
    };
    setSignatories(newSignatories);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log({ ...formData, signatories });
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Ekspeditionsoplysninger</h1>
      </div>
      
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-2xl">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Kunde
              </label>
              <input
                type="text"
                name="customer"
                value={formData.customer}
                onChange={handleChange}
                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Debitor nr.
              </label>
              <input
                type="text"
                name="debtorNumber"
                value={formData.debtorNumber}
                onChange={handleChange}
                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Aftale nr.
              </label>
              <input
                type="text"
                name="agreementNumber"
                value={formData.agreementNumber}
                onChange={handleChange}
                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <div className="border-t pt-6">
            <h2 className="text-lg font-semibold mb-4">Tegningsberettiget</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Antal
                </label>
                <input
                  type="number"
                  value={signatoryCount}
                  onChange={handleSignatoryCountChange}
                  min="1"
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            {signatories.map((signatory, index) => (
              <div key={index} className="mt-4 p-4 bg-gray-50 rounded-lg">
                <h3 className="text-sm font-medium text-gray-700 mb-4">
                  Tegningsberettiget {index + 1}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Navn
                    </label>
                    <input
                      type="text"
                      value={signatory.name}
                      onChange={(e) => handleSignatoryChange(index, 'name', e.target.value)}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Mail
                    </label>
                    <input
                      type="email"
                      value={signatory.email}
                      onChange={(e) => handleSignatoryChange(index, 'email', e.target.value)}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      CPR-nummer
                    </label>
                    <input
                      type="text"
                      value={signatory.cprNumber}
                      onChange={(e) => handleSignatoryChange(index, 'cprNumber', e.target.value)}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-end gap-4 pt-6">
            <button
              type="button"
              className="px-4 py-2 text-gray-600 hover:text-gray-800"
            >
              Annuller
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Gem
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}